export const getLocation = async (maxRetries = 3) => {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const result = await new Promise((resolve, reject) => {
                if (!navigator.geolocation) {
                    reject(new Error('Geolocation is not supported by this browser.'));
                    return;
                }

                const options = {
                    enableHighAccuracy: attempt === 1, // First try high accuracy
                    timeout: 10000 + (attempt * 5000), // Increase timeout: 15s, 20s, 25s
                    maximumAge: attempt * 60000 // Accept older locations on retries
                };

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        resolve({ latitude, longitude });
                    },
                    (error) => {
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                reject(new Error('Location permission denied by the user.'));
                                break;
                            case error.POSITION_UNAVAILABLE:
                                reject(new Error('Location information is unavailable.'));
                                break;
                            case error.TIMEOUT:
                                reject(new Error('The request to get location timed out.'));
                                break;
                            default:
                                reject(new Error('An unknown error occurred while retrieving location.'));
                                break;
                        }
                    },
                    options
                );
            });

            console.log(`Location obtained on attempt ${attempt}`);
            return result;

        } catch (error) {
            console.warn(`Location attempt ${attempt}/${maxRetries} failed:`, error.message);

            if (attempt === maxRetries) {
                throw error;
            }

            // Wait before retry
            await new Promise(resolve => setTimeout(resolve, 2000));
        }
    }
};